import { Format } from './format.interface';
import { Card, Query } from '@deckplan.io/common';

export class Standard extends Format {

    public addCardsQuery(): Query {
        return {
            dataField: {
                title: 'Legalities',
                field: 'legalities',
                dataType: 'string'
            },
            operation: 'includes',
            value: `"standard":"legal"`
        };
    }

    public validate(): Card[] {
        return this.deck.cards.filter(c =>
            // All cards not legal in standard are invalid
            c.legalities.standard === 'not_legal'
        );
    }
}
